import { RDEqipHasFarmInfo } from '@cibo/core'
import { ResourceDetailFeature } from '@cibo/ui'
import { RDEqipHasFarmInfoTaskEditor } from './RDEqipHasFarmInfoTaskEditor'

export const RDEqipHasFarmInfoResourceDetailFeature: ResourceDetailFeature<RDEqipHasFarmInfo> = {
  traitId: 'eqipHasFarmInfo',
  TaskEditor: RDEqipHasFarmInfoTaskEditor,
}
